<template>
  <div class="c-m-lr-30">
    <!-- <gLine size="18"></gLine> -->
    <div class="c-f-bt">
      <!-- <div
        class="c-p-24 c-h-172 c-f-cl c-b-r-16 main_btn_con"
        @click="handleToPage('PointMall')"
      > -->
      <div
        class="c-p-24 c-h-172 c-f-cl c-b-r-16 main_btn_con no_open_con"
        @click="$toast('暂未开放敬请期待')"
      >
        <div class="round_box">
          <img src="@/assets/svg/round.svg" alt="" :style="{ width: '48px' }" />
        </div>
        <div class="c-f-bt c-zindex-1">
          <div class="c-ft-32 bold-600">积分商城</div>
          <div>
            <img
              src="@/assets/svg/points.svg"
              alt=""
              :style="{ width: '24px' }"
            />
            <!-- <gImg2 src="@/assets/svg/points.svg" size="48"></gImg2> -->
          </div>
        </div>
      </div>

      <div
        class="c-p-24 c-h-172 c-f-cl c-b-r-16 main_btn_con"
        @click="handleToPage('SettleAccounts')"
      >
        <div class="round_box">
          <img src="@/assets/svg/round.svg" alt="" :style="{ width: '48px' }" />
          <!-- <gImg2 src="@/assets/svg/round.svg" size="96"></gImg2> -->
        </div>
        <div class="c-f-bt c-zindex-1">
          <div class="c-ft-32 bold-600">自助结账</div>
          <div>
            <img
              src="@/assets/svg/memberBuy.svg"
              alt=""
              :style="{ width: '24px' }"
            />
            <!-- <gImg2 src="@/assets/svg/memberBuy.svg" size="48"></gImg2> -->
          </div>
        </div>
        <!-- <div class="ft-24 z-1 p-t-10 skeleton-rect">无需等待!</div> -->
        <div class="c-ft-24 c-f-bt">
          <!-- <div class="w-block">
                <div>
                  无需等待!
                </div>
              </div> -->
          <div class="z-10">
            <img src="@/assets/svg/fish.svg" alt="" :style="{ width: '8px' }" />
            <!-- <gImg2
              src="@/assets/svg/fish.svg"
              width="17"
              height="36"
              top="10"
            ></gImg2> -->
          </div>
        </div>
      </div>
    </div>
    <gLine size="18"></gLine>
    <!-- 排队 box -->
    <div class="c-f-bt">
      <div class="c-h-172 c-w-220 c-b-r-30 c-f-ar main_second_con">
        <div>
          <div class="c-fc-center" @click="handleToScan">
            <img
              src="@/assets/svg/queue.svg"
              alt=""
              :style="{ width: '25px' }"
            />
            <p class="c-m-t-20">扫码取号</p>
            <!-- <gImg2
              src="@/assets/svg/queue.svg"
              size="50"
              title="排队取号"
              txtTop="20"
            ></gImg2> -->
          </div>
        </div>
      </div>

      <div class="c-h-172 c-w-220 c-b-r-30 c-f-ar main_second_con no_open_con">
        <div>
          <div class="c-fc-center" @click="$toast('暂未开放敬请期待')">
            <img
              src="@/assets/svg/member.svg"
              alt=""
              :style="{ width: '25px' }"
            />
            <p class="c-m-t-20">会员权益</p>
            <!-- <gImg2
              src="@/assets/svg/member.svg"
              size="50"
              title="会员权益"
              txtTop="20"
            ></gImg2> -->
          </div>
        </div>
      </div>
      <div class="c-h-172 c-w-220 c-b-r-30 c-f-ar main_second_con">
        <div @click="handleToPage('Order')">
          <div class="c-fc-center">
            <img
              src="@/assets/svg/order.svg"
              alt=""
              :style="{ width: '25px' }"
            />
            <p class="c-m-t-20">我的订单</p>
            <!-- <gImg2
              src="@/assets/svg/order.svg"
              size="50"
              title="我的订单"
              txtTop="20"
            ></gImg2> -->
          </div>
          <!-- <div>我的订单</div> -->
        </div>
      </div>
    </div>
    <gLine size="18"></gLine>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "ButtonList",
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleToScan() {
      // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
      handleScanCode();
    },
    handleToPage(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.main_btn_con {
  position: relative;
  background: #fff;
  color: #333;
  width: 49%;
  box-sizing: border-box;
  box-shadow: 0px 20px 40px 0px rgba(213, 213, 213, 0.5);
  .round_box {
    position: absolute;
    top: 8px;
    left: 8px;
  }
}
.main_second_con {
  background: #fff;
  box-shadow: 0px 20px 40px 0px rgba(213, 213, 213, 0.5);
}
.no_open_con {
  background: #f7f7f7;
}
</style>
